<template>
    <teleport to="head">
        <link rel="canonical" :href="$route.path" />
        <meta name="keywords" :content="metaKeyword">
        <meta name="description" :content="metaDescription">
        <meta name="author" content="HGSHYDRO">
        <meta name="publisher" content="HGSHYDRO">
    </teleport>
</template>

<script>
export default {
    name: 'LocationSchemaJson',
    props: ['metaKeyword', 'metaDescription'],
    data() {
        return {
           locationMetaKeyword: "",
           locationMetaDescription: ""
        }
    },
    watch:{
        metaKeyword: {
            handler: function(metaKeyword) {
                this.locationMetaKeyword = metaKeyword;
            }
        },
        metaDescription: {
            handler: function(metaDescription) {
                this.locationMetaDescription = metaDescription;
            }
        }
    }
}   
</script>
